
    import { setupDynatraceUserTagging } from './src/dynatraceUserTag.ts';
    setupDynatraceUserTagging();
  